import { useQuery } from "@tanstack/react-query";
import api from "../api/api";
import useUrlQuery from "../hooks/useUrlQuery";

// Define PolicyResponse type according to the expected API response structure
type PolicyResponse = {
  data: {
    POLICY_DATA: Array<{
      POLICY_DOC?: string;
      [key: string]: any;
    }>;
    [key: string]: any;
  };
  [key: string]: any;
};

export const useGetPolicyDetails = () => {
  const { getUrlQuery } = useUrlQuery();
  const proposal_id = getUrlQuery("proposal_id");

  const { data, isLoading } = useQuery<PolicyResponse>({
    queryKey: ["getPolicyDetails", proposal_id],
    queryFn: () =>
      api.post("api/GetHealthPolicyDetails", {
        PROPOSAL_ID: proposal_id,
      }),
  });

  return {
    policy_data: data?.data?.POLICY_DATA?.[0],
    pdf: data?.data?.POLICY_DATA?.[0]?.POLICY_DOC,
    isPolicyLoading: isLoading,
  };
};